import Input from "app/components/UI/Input";
import PropTypes from "prop-types";
import React from "react";
import classes from "./SearchInput.module.css";

export const SearchInput = ({ block, placeholder = "Rechercher...", className, ...props }) => (
  <div className={className}>
    <Input className={classes.searchInput__field} placeholder={placeholder} block={block} {...props} />
  </div>
);

SearchInput.propTypes = {
  block: PropTypes.bool,
  placeholder: PropTypes.string
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/app/components/UI/SearchInput/SearchInput.js